import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { ExtensionProps, NodeHoc, RicosExtension, RicosExtensionConfig } from './../../ricos-types';
import { createRicosFunctionalExtension } from './../../plugin-commons';
import type { TiptapAdapterServices } from './../../tiptap-editor/initializeTiptapAdapter';

import Resizer from './resizer';

export const resizable = createRicosFunctionalExtension({
  type: 'extension',
  groups: [],
  name: 'ricos-resizable',
  reconfigure(
    config: RicosExtensionConfig,
    extensions: RicosExtension[],
    _ricosProps: ExtensionProps,
    _settings: Record<string, unknown>,
    services: TiptapAdapterServices
  ) {
    const types = extensions
      .filter(extension => !(services.context.isMobile && extension.name === Node_Type.IMAGE))
      .filter(extension => extension.groups.includes('resizable'))
      .map(({ name }) => name);

    return {
      ...config,
      priority: 80,
      addNodeHoc: () => {
        return {
          nodeTypes: types,
          nodeHoc: Resizer as NodeHoc,
          priority: 80,
        };
      },
    };
  },
  createExtensionConfig() {
    return {
      name: this.name,
    };
  },
});
